var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import getLabels from '../../requests/label/getLabels';
/**
 *
 */
var GetOrganisationLabelsCommand = /** @class */ (function (_super) {
    __extends(GetOrganisationLabelsCommand, _super);
    function GetOrganisationLabelsCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param organisationId string
     * @param labelCollection LabelCollection
     * @return {*}
     */
    GetOrganisationLabelsCommand.prototype.execute = function (organisationId, labelCollection) {
        this.labelCollection = labelCollection;
        if (this.labelCollection.fetching) {
            return labelCollection.fetching;
        }
        else {
            labelCollection.fetching = getLabels(organisationId, !this.labelCollection.firstFetchComplete).then(this.then).catch(this.catch);
            return labelCollection.fetching;
        }
    };
    /**
     *
     * @param response
     */
    GetOrganisationLabelsCommand.prototype.then = function (response) {
        this.labelCollection.fetching = null;
        this.labelCollection.reset(false);
        this.labelCollection.addAll(response);
    };
    /**
     *
     * @param error
     */
    GetOrganisationLabelsCommand.prototype.catch = function (error) {
        this.labelCollection.fetching = null;
    };
    return GetOrganisationLabelsCommand;
}(Command));
export default GetOrganisationLabelsCommand;
